export default __webpack_public_path__ + "static/media/role.f944311e.png";